import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["price", "qty", "cost", "sumMaterials", "labour", "total", "preview"]
  static values = { rate: Number, limit: String }

  connect() { this.update() }

  parse(el) {
    if (!el) return NaN
    const cleaned = String(el.value).replace(/[\s\u00A0\u2007\u2008\u2009\u200A\u200B\u200C\u200D\uFEFF]+/g, "").replace(",", ".")
    return cleaned === "" ? NaN : Number(cleaned)
  }

  fmt(n) { return n.toFixed(2).replace(".", ",") }

  update() {
    let materials = 0
    let known = true
    this.qtyTargets.forEach((qtyEl, i) => {
      const q = this.parse(qtyEl)
      const p = this.parse(this.priceTargets[i])
      if (Number.isFinite(q) && Number.isFinite(p)) {
        materials += q * p
      } else {
        known = false
      }
    })
    if (!this.hasPreviewTarget) return
    if (!known) { this.previewTarget.textContent = ""; return }
    const labour = Math.round(materials * this.rateValue * 100) / 100
    const total = materials + labour
    const limit = Number(String(this.limitValue).replace(",", "."))
    const overText = Number.isFinite(limit) && total > limit + 0.01 ? " - przekracza limit ceny zam\u00F3wienia!" : ""
    this.previewTarget.textContent =
      `Podpowied\u017C: materia\u0142y ${this.fmt(materials)} z\u0142, robocizna ${this.fmt(labour)} z\u0142, razem ${this.fmt(total)} z\u0142${overText}`
  }
}
